import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "restaumatic-client";
import PreactModal, { ModalHeader } from "../../components/PreactModal";
import LocateMeButton from "../../components/LocateMeButton";
import StreetAddressForm from "../../components/StreetAddressForm";
import Alert from "../../components/Alert";
function FulfillmentAddressModal(props) {
    const { id, deliveryAddressCoordinator, onSubmit, onHidden } = props;
    const { validationStatus } = deliveryAddressCoordinator.deliveryAddressController;
    const isLoading = validationStatus.type === "Loading" ||
        deliveryAddressCoordinator.isGeolocationLoading;
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };
    return (h(PreactModal, { id: id, onHidden: onHidden },
        h("form", { id: "fulfillment-address-form-modal", onSubmit: handleSubmit },
            h(ModalHeader, { title: translate(t.order.delivery_address) }),
            h("div", { class: "modal-body" },
                h(FromFields, { deliveryAddressCoordinator: deliveryAddressCoordinator })),
            h("div", { class: "modal-footer modal-footer--sticky" },
                h("button", { type: "submit", form: "fulfillment-address-form-modal", class: "btn btn-primary btn-block", disabled: isLoading }, isLoading ? (h("span", { class: "icon-spinner icon-spin" })) : (translate(t.actions.save)))))));
}
function FromFields(props) {
    const { deliveryAddressCoordinator } = props;
    const { deliveryAddressController: controller } = deliveryAddressCoordinator;
    const handleLocateMe = () => {
        void deliveryAddressCoordinator.locateMe();
    };
    return (h(Fragment, null,
        h(LocateMeButton, { onLocateMe: handleLocateMe, isLoading: deliveryAddressCoordinator.isGeolocationLoading, geolocationError: deliveryAddressCoordinator.geolocationError }),
        h("div", { class: "m-delivery-address__container" },
            h(StreetAddressForm, { fieldId: "fulfillmentMethod.deliveryAddress", controller: controller })),
        h("div", { class: "m-delivery-address__status" },
            h(AddressStatus, { state: controller.validationStatus }))));
}
const AddressStatus = observer((props) => {
    const { state } = props;
    switch (state.type) {
        case "NetworkError":
            return (h(Alert, { type: "danger", message: translate(t.errors.messages.network) }));
        case "AddressDoesNotExistOrInaccurate":
            return (h(Alert, { type: "danger", message: translate(t.delivery.geocoding_error) }));
        default:
            return null;
    }
});
export default observer(FulfillmentAddressModal);
